<template>
    <div class="min-h-screen bg-brand-gray50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <Logo class="text-purple-700 mx-auto h-16 w-auto"></Logo>
        <CodeLookup v-if="step===1" 
                @code-validated="validated"></CodeLookup>
        <EmailLookup v-else-if="step===2"
                message="Hello, Let's get you registered"
                @email-not-found="emailNotFound"
                @email-validated="emailValidated"></EmailLookup>
        <CreateAccount v-else-if="step==='3a'" 
                :registration-code="code" 
                @account-created="accountCreated"></CreateAccount>
        <Login v-else-if="step==='3b'" 
                :user="user" 
                @login-complete="loginComplete"></Login>
        <CompleteRegistration v-else-if="step === 4"
                :user="user"
                :code="code"
        />
        <Complete v-else></Complete>
    </div>
</template>

<script>
import CodeLookup from './book-store/CodeLookup';
import EmailLookup from './book-store/EmailLookup';
import Login from './book-store/Login';
import Logo from './book-store/Logo';
import CreateAccount from './book-store/CreateAccount';
import Complete from './book-store/Complete';
import ShippingInformation from "./book-store/ShippingInformation";
import CompleteRegistration from './book-store/CompleteRegistration';

export default {
    name: 'BookstoreRedemption',
    components: {
        Complete,
        CompleteRegistration,
        CreateAccount,
        CodeLookup,
        EmailLookup,
        Logo,
        Login,
        ShippingInformation
    },

    data() {
        return {
            code: null,
            emailAddress: null,
            step: 1,
            user: null,
            shippingAddress: null
        };
    },

    computed: {
        validCode() {
            return this.code !== null;
        }
    },

    mounted() {
    },

    methods: {
        accountCreated(user) {
            this.user = user;
            this.step = 4;
        },

        validated(code) {
            this.code = code;
            this.step = 2;
        },

        emailNotFound(email) {
            this.step = '3a';
            this.emailAddress = email;
        },

        emailValidated(data){
            this.step = '3b';
            this.user = data;
        },

        loginComplete(){
            this.step = 4;
        }
    }
};
</script>

<style scoped>

</style>